import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from "../app/authentication/auth.guard";
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';


export const Approutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      //  { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
      { path: '', redirectTo: '/authentication/login', pathMatch: 'full' },
      { path: 'app', loadChildren: './dashboards/dashboard.module#DashboardModule', canActivate: [AuthGuard] },
      { path: 'starter', loadChildren: './starter/starter.module#StarterModule', canActivate: [AuthGuard] },
      { path: 'apps', loadChildren: './apps/apps.module#AppsModule', canActivate: [AuthGuard] },
      { path: 'webapps', loadChildren: './webapps/webapps.module#WebAppsModule', canActivate: [AuthGuard] },
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: './authentication/authentication.module#AuthenticationModule'
      },
      {
        path: 'maintenance-tenant-portal',
        loadChildren: './maintenance-tenant-portal/maintenance-tenant-portal.module#MaintenanceTenantPortalModule'
      }
    ]
  },
  {
    path: 'login',
    redirectTo: '/authentication/login'
  },
  {
    path: 'register',
    redirectTo: '/authentication/register'
  },
  {
    path: '**',
    redirectTo: '/authentication/404'
  },
  {
    path: 'welcome',
    redirectTo: '/authentication/welcome'
  }
  ,
  {
    path: 'firebase-messaging-sw.js',
    redirectTo: '/firebase-messaging-sw.js'
  },
];
@NgModule({
  imports: [RouterModule.forRoot(Approutes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
